import { render } from "./chart-collection.vue?vue&type=template&id=8814b804"
import script from "./chart-collection.vue?vue&type=script&lang=js"
export * from "./chart-collection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__